<div class="mt-4">
  <div class="welcome-screen container-sm mt-5 pt-5">
    <div class="row justify-content-center">
      <div class="col-md-5">
        <div class="card shadow-lg p-5">
          <div class="card-title title text-center">
            <label for="signaturePad"
                   class="col-form-label title  text-center"><i
              class="{{!isPresentRubric ? 'fas fa-plus-circle':'fas fa-pencil-alt'}}"
              aria-hidden="true"></i> {{ !isPresentRubric ? "Agregar rúbrica" : "Actualizar rúbrica"}}
            </label>
            <hr>
          </div>
          <p class="text-center" *ngIf="!isPresentRubric">Por favor, suba una imagen de su firma en formato PNG o JPG.
            Si lo prefiere, puede usar la opción <b>'Dibujar'</b> para hacer su firma directamente en el sistema, como
            si la estuviera firmando en papel.</p>
          <div
            class="alert {{alertType === 'alert-danger' ? 'alert-danger': 'alert-success'}} alert-dismissible fade show"
            role="alert" *ngIf="showError">
            <div class="font-weight-normal">
              <i
                class="{{alertType === 'alert-danger' ? 'alert-danger text-danger': 'alert-success text-success'}} fa fa-info-circle"></i>&nbsp; {{messageAlert}}
            </div>
            <button type="button" class="close" data-dismiss="alert" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div [hidden]="!isPresentRubric">
            <div class="text-center align-content-center">
              <div class="offset-md-0 font-weight-light">
                <div class="custom-file">
                  <button type="button"
                          id="signaturePad"
                          class="btn btn-block btn-outline-success btn-mxw"
                          (click)="changeRubric()">
                    <i class="fa fa-sync-alt"></i> {{ "BUTTON.UPDATE" | translate }}
                  </button>
                </div>
              </div>
              <div class="col-md-12">
                <label for="signaturePad"
                       class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
                <div>
                  <img [src]="defaultRubricSrc" width="100%" height="30%" alt="Rubric">
                </div>
              </div>
            </div>
            <br>
            <div class="card-footer">
              <div class="buttons">
                <button class="btn btn-danger"
                        (click)="backPreview()">
                  <i class="fa fa-reply"></i> {{ "BUTTON.BACK" | translate }}
                </button>
                <button class="submit btn btn-success" *ngIf="!isCloudSignature && !isRemoteSignature"
                        (click)="signDocument()">
                  <i class="fas fa-signature"></i> {{ "BUTTON.SIGN" | translate }}
                </button>
                <button class="submit btn btn-success" *ngIf="isCloudSignature || isRemoteSignature"
                        (click)="signDocument()">
                  <i class="fa fa-arrow-right"
                     aria-hidden="true"></i> {{ "BUTTON.NEXT" | translate }}
                </button>
              </div>
            </div>
          </div>
          <mat-tab-group animationDuration="0ms" [hidden]="isPresentRubric">
            <form [formGroup]="signaturePadForm">
              <mat-tab class="tab">
                <ng-template mat-tab-label class="active">
                  <div class="font-weight-bold">
                    <i class="fas fa-image"></i> {{"TITLE.ADD-IMAGE" | translate}}
                  </div>
                </ng-template>
                <div class="host">
                  <div class="custom-file">
                    <input type="file"
                           class="custom-file-input"
                           accept="image/jpeg, image/png"
                           alife-file-to-base64
                           id="customRubricFile"
                           (change)="readSelectedRubric($event)"
                           (onFileChanged)="changeStatus($event)">
                    <small *ngIf="isInvalidControl('rubricFilename2Show')"
                           class="text-danger">
                      {{ "MESSAGE.SELECT-RUBRIC" | translate }}
                    </small>
                    <div class="custom-file-label">
                      <label for="customRubricFile">
                        {{signaturePadForm.get('rubricFilename2Show').value ? signaturePadForm.get('rubricFilename2Show').value : ('MESSAGE.SELECT' | translate)}}
                      </label>
                    </div>
                  </div>
                  <div class="host ng-star-inserted">
                    <label for="customRubricFile"
                           class="col-form-label">{{ "LABEL.PREVIEW" | translate }}</label>
                    <div>
                      <img [src]="defaultRubricSrc" width="100%" height="30%"
                           alt="Rubric">
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="buttons">
                      <button class="btn btn-danger"
                              [disabled]="isFirstAddRubric"
                              (click)="goBack()">
                        <i class="fa fa-times"></i> {{ "BUTTON.CANCEL" | translate }}
                      </button>
                      <button class="submit btn btn-success"
                              [disabled]="!isReady2Save"
                              (click)="saveSignature()">
                        <i class="fa fa-check-circle"></i> {{ "BUTTON.ACCEPT" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </mat-tab>
              <mat-tab class="tab">
                <ng-template mat-tab-label>
                  <div class="font-weight-bold">
                    <i class="fas fa-pen"></i> {{"TITLE.DRAW" | translate}}
                  </div>
                </ng-template>
                <div class="host">
                  <canvas #canvas width="350" height="200" (mousedown)="startDrawing($event)"
                          (mousemove)="draw($event)" (mouseup)="stopDrawing()"
                          (mouseleave)="stopDrawing()"></canvas>
                  <div class="row mt-2 mt-2 mt-2-custom">
                    <div class="col-3 offset-md-9">
                      <label (click)="clearSignature()" class="col-form-label"
                             style="color: #dc3545;">
                        <i class="fas fa-trash"></i> {{ "LABEL.ERASE" | translate }}
                      </label>
                    </div>
                  </div>
                  <div class="row mt-2 mt-2-custom">
                    <div class="col-6">
                      <label for="lineWitdh"
                             class="col-form-label">{{ "LABEL.SIZE" | translate }}</label>
                      <select class="form-control"
                              id="lineWitdh"
                              formControlName="lineWitdh"
                              [(ngModel)]="lineWitdh">
                        <option [value]=4>4</option>
                        <option [value]=5>5</option>
                        <option [value]=6>6</option>
                        <option [value]=7>7</option>
                        <option [value]=8>8</option>
                        <option [value]=9>9</option>
                      </select>
                    </div>
                    <div class="col-6">
                      <label for="strokeColor"
                             class="col-form-label">{{ "LABEL.COLOR" | translate }}</label>
                      <select class="form-control"
                              id="strokeColor"
                              formControlName="strokeColor"
                              [(ngModel)]="strokeColor">
                        <option value="black">negro</option>
                        <option value="green">verde</option>
                        <option ngValue="blue">azul</option>
                      </select>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div class="buttons">
                      <button class="btn btn-danger"
                              [disabled]="isFirstAddRubric"
                              (click)="goBack()">
                        <i class="fa fa-times"></i> {{ "BUTTON.CANCEL" | translate }}
                      </button>

                      <button class="submit btn btn-success"
                              [disabled]="!isDrawComplete"
                              (click)="saveDrawSignature()">
                        <i class="fa fa-check-circle"></i> {{ "BUTTON.ACCEPT" | translate }}
                      </button>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </form>
          </mat-tab-group>
        </div>
      </div>
    </div>
  </div>
</div>
<app-loading *ngIf="loading || loadingSign"></app-loading>
